import { Typography } from '@arionbanki/arionui';
import { useState } from 'react';
import type { BulkCancelHook } from './useBulkCancel';

type BulkCancelDoneStepProps = { bulk: BulkCancelHook };

export function BulkCancelDoneStep({ bulk }: Readonly<BulkCancelDoneStepProps>) {
	const { result, t } = bulk;
	const [copied, setCopied] = useState(false);
	if (!result) return null;
	const copyBatchId = () => {
		navigator.clipboard.writeText(result.batchId);
		setCopied(true);
	};
	return (
		<>
			<Typography TagName="h4">{t('admin_bulk_success') || 'Processes cancelled'}</Typography>
			<div className="admin-bulk__count">
				{t('admin_bulk_cancelled_count') || 'Cancelled processes'}: <strong>{result.cancelledCount}</strong>
			</div>
			<div className="admin-bulk-batch">
				<div className="admin-drawer-label">
					{t('admin_bulk_batch_id') || 'Batch ID (keep this — it is required for a revert)'}
				</div>
				<button
					className="admin-drawer-guid"
					onClick={copyBatchId}
					title={t('copy_to_clipboard')}
					type="button"
				>
					{result.batchId} ⧉
				</button>
				{copied && <span className="admin-bulk-batch__copied">{t('copied') || 'Copied'}</span>}
			</div>
			<div className="admin-drawer-actions__row">
				<button className="admin-drawer-btn admin-drawer-btn--back" onClick={bulk.reset} type="button">
					{t('admin_bulk_start_over') || 'Start over'}
				</button>
			</div>
		</>
	);
}
